import type { PropsWithChildren } from 'react';
import { useCallback, useRef, useState } from 'react';

import type { EmptyObject } from 'type-fest';

import { useMutationObserver } from 'src/app/shared/hooks/dom';

export function MutationObserverContainer({ children }: PropsWithChildren<EmptyObject>): JSX.Element {
	const mutationRef = useRef(null);
	const [mutationCount, setMutationCount] = useState(0);
	const incrementMutationCount = useCallback(() => {
		return setMutationCount((count) => count + 1);
	}, []);

	useMutationObserver(mutationRef, incrementMutationCount, {
		attributes: true,
		characterData: false,
		childList: false,
		subtree: false,
	});

	return (
		<div data-testid="sap-container" key={mutationCount} ref={mutationRef}>
			{children}
		</div>
	);
}
